import { Label } from "@/components/ui/label";

interface RequiredLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
  hint?: string;
  error?: string | null;
}

export function RequiredLabel({ htmlFor, children, required, hint, error }: RequiredLabelProps) {
  return (
    <div className="flex items-baseline justify-between gap-2">
      <Label htmlFor={htmlFor} required={required}>
        {children}
      </Label>
      {error ? (
        <span className="text-xs text-red-600">{error}</span>
      ) : hint ? (
        <span className="text-xs text-slate-400">{hint}</span>
      ) : null}
    </div>
  );
}
